var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilledPencilOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#F60"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.333 18.236c.88 0 1.594.714 1.594 1.594 0 .88-.713 1.594-1.594 1.594H5.594c-.88 0-1.594-.713-1.594-1.594 0-.88.714-1.594 1.594-1.594h12.74zM8.535 3.12l8.442 8.442c.123.123.2.272.24.428.004.01.01.016.013.027l.966 3.871c.123.496-.325.944-.82.82l-3.837-.957-.021-.006-.013-.003-.006-.003c-.165-.038-.323-.119-.451-.248L6.323 8.765l2.592-2.591c.228-.23.228-.6 0-.83-.229-.229-.6-.229-.829 0L5.493 7.938l-.887-.888c-.367-.368-.367-.964 0-1.332L7.204 3.12c.367-.368.964-.368 1.331 0z",
    transform: "translate(-924 -1377) translate(924 1377)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilledPencilOrange);
export default __webpack_public_path__ + "static/media/icon-filled-pencil--orange.68d41475bff363af40fea724fe1b3444.svg";
export { ForwardRef as ReactComponent };